module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "action-icons-bar",
    style: ({
      'background-color': this.$store.state.campaign.color
    }),
    attrs: {
      "height": "67px",
      "card": ""
    }
  }, [_c('v-toolbar-title', [(this.$store.state.isLowRes) ? _c('v-btn', {
    staticClass: "left-arrow-back",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.minimizeWindow.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "28px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.campaign.show_agent && !_vm.$store.state.interaction.transfering) ? _c('div', {
    staticClass: "avatar-agent-pic",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'background-image': 'url(' + _vm.$store.state.menu.menu_img + ')'
    })
  }) : (!_vm.$store.state.interaction.transfering) ? _c('div', {
    staticClass: "avatar-agent-pic",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'background-image': 'url(' + _vm.avatar + ')'
    })
  }) : (_vm.$store.state.interaction.transfering) ? _c('div', {
    staticClass: "avatar-agent-pic",
    class: {
      'isLowRes': this.$store.state.isLowRes
    }
  }, [_c('v-icon', {
    staticClass: "spinIcon",
    staticStyle: {
      "font-size": "50px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("\n          sync\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.campaign.show_agent && !_vm.$store.state.interaction.transfering) ? _c('span', {
    staticClass: "agent-name",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$store.state.interaction.agent))]) : (!_vm.$store.state.campaign.show_agent && !_vm.$store.state.interaction.transfering) ? _c('span', {
    staticClass: "agent-name",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v("CHAT")]) : (_vm.$store.state.interaction.transfering) ? _c('span', {
    staticClass: "agent-name",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$t('transfering')))]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.interaction.transfering) ? _c('p', {
    staticClass: "response-time",
    class: {
      'isLowRes': this.$store.state.isLowRes
    },
    style: ({
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    })
  }, [_vm._v(_vm._s(_vm.$t('available')))]) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [(_vm.allowedCalls && _vm.hasWebRTC && !_vm.hideButtons && !_vm.$store.state.interaction.transfering) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "chatbar-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoCall.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("videocam")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('videocall')))])], 1) : _vm._e(), _vm._v(" "), (_vm.allowedCalls && _vm.hasWebRTC && !_vm.hideButtons && !_vm.$store.state.interaction.transfering) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "chatbar-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.makeCall.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('call')))])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "chatbar-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openCloseModal.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('endchat')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebe11a04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-toolbar.vue
// module id = 420
// module chunks = 2